// extracted by mini-css-extract-plugin
export default {"info-container":"styles_info-container__MFjwx","info":"styles_info__vytpv"};